import React, { useEffect, useRef, useState } from 'react'
import { styled } from "@mui/material/styles";
import { Container, Box, Paper, Typography, Table, TableBody, TableCell, TableRow, Card, CardContent, Link, Divider, Grid, Button } from "@mui/material";
import { Form, Formik } from 'formik';
import CustomInputLogin from '../../../../Components/CustomInputLogin/CustomInputLogin';
import CustomDropdownMui from '../../../../Components/CustomDropDown/CustomDropdown';
import CustomFromAndToDate from '../../../../Components/CustomFromAndToDate/CustomFromAndToDate';
import actions from '../../../../ReduxStore/actions';
import { useDispatch, useSelector } from 'react-redux';

import * as Yup from 'yup';
import { toast, ToastContainer } from 'react-toastify';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';

const ProfileContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    padding: theme.spacing(2),
}));


const ResponsiveBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));

const validationSchema = Yup.object().shape({
    RequirementCampus: Yup.string().required('Campus is required'),
    mentor: Yup.string().required('This field is required'),
    Expertise: Yup.string().required('Expertise is required'),
    TotalVacancies: Yup.number()
        .typeError('Must be a number')
        .required('Total vacancies is required')
        .min(1, 'Minimum 1 vacancy'),
    fromDate: Yup.date()
        .required('From Date is required')
        .typeError('Invalid date'),
    toDate: Yup.date()
        .required('To Date is required')
        .min(
            Yup.ref('fromDate'),
            'To Date must be later than From Date'
        )
        .typeError('Invalid date'),
    details: Yup.string()
        .required('Details are required')
        .min(10, 'Enter at least 10 characters'),
});



const MentorRequirement = ({ handleAddFormGoBackButton, editById, setEditById }) => {
    const [uploadedFile, setUploadedFile] = useState(null);
    const dispatch = useDispatch()

    const campusName = [
        { value: "Campus", label: "Campus" },

    ];
    const mentorList = [
        { value: "Jury Member", label: "Jury Member" },
        { value: "Expert Lecture", label: "Expert Lecture" },
        { value: "Mentor", label: "Mentor" },
    ];

    const categoryList = [
        { value: "Accessories", label: "Accessories" },
        { value: "Accounts", label: "Accounts" },
        { value: "Animator", label: "Animator" },
        { value: "Artist", label: "Artist" },
        { value: "e-commerce", label: "e-commerce" },
        { value: "Engineering", label: "Engineering" },
        { value: "Fashion", label: "Fashion" },
        { value: "Film", label: "Film" },
        { value: "Garment manufacturing", label: "Garment manufacturing" },
        { value: "Graphic design", label: "Graphic design" },
        { value: "Knitwear", label: "Knitwear" },
        { value: "Leather", label: "Leather" },
        { value: "Management", label: "Management" },
        { value: "online business", label: "online business" },
        { value: "Others", label: "Others" },
        { value: "Product design", label: "Product design" },
        { value: "Retail", label: "Retail" },
        { value: "Scientist", label: "Scientist" },
        { value: "Software expert", label: "Software expert" },
        { value: "Textiles", label: "Textiles" },
    ];
    const { MentorRequirementPost } = useSelector(
        (state) => state?.MentorRequirementPost
    );
    const formikRef = useRef();
    const [loading, setLoading] = useState(false);


    useEffect(() => {


        if (editById) {

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getMentorRequirementById/${editById}`,
                };
                const response = await dispatch(actions.MENTORREQUIREMENTGETBYID(data1));

                console.log(response, "responseresponse")
                const { setFieldValue } = formikRef.current;


                if (response?.payload?.message === "Mentor requirement fetched successfully.") {
                    //     console.log("hiiii")
                    setFieldValue("RequirementCampus", response?.payload?.data?.campus_requirement)
                    setFieldValue("TotalVacancies", response?.payload?.data?.vacancies)
                    setFieldValue("mentor", response?.payload?.data?.mentor_type)

                    setFieldValue("details", response?.payload?.data?.requirements)
                    setFieldValue("Expertise", response?.payload?.data?.expertise)
                    setFieldValue("fromDate", response?.payload?.data?.from_date)
                    setFieldValue("toDate", response?.payload?.data?.to_date)




                }
            };
            fetchData();
        }

    }, []);

    const sessionAdminId = sessionStorage.getItem("adminId")

    const handleSubmit = async (values, { resetForm }) => {
        console.log("Form Values of contact form:", values);
        setLoading(true)
        const data1 = {
            data: {
                user_id: Number(sessionAdminId),

                campus_requirement: values?.RequirementCampus,
                mentor_type: values?.mentor,
                expertise: values?.Expertise,
                vacancies: values?.TotalVacancies,
                from_date: values?.fromDate,
                to_date: values?.toDate,
                requirements: values?.details

            },
            // method: "post",
            method: editById ? "put" : "post",

            apiName: editById ? `updateMentorRequirement/${editById}` : `createMentorRequirement`,
            // isFormData: true,
        };

        const responseData = await dispatch(editById ? actions.UPDATEMENTORREQUIREMENT(data1) : actions.MENTORREQUIREMENTPOST(data1));
        // if (responseData?.payload?.error === false && responseData?.payload?.loading === false) {
        if (responseData?.payload?.message === editById ? "Mentor requirement updated successfully." : "Mentor requirement posted successfully.") {
            setLoading(false)

            // toast.success(`Jury member/ expert lecture/ mentor requirement is ${editById ? "updated" : "created"} successfully`)

            // toast.success(`Event is ${editById ? "updated" : "created"} successfully`)
            toast.success(`Jury member/ expert lecture/ mentor requirement is ${editById ? "updated" : "created"} successfully`);


            setTimeout(() => {
                handleAddFormGoBackButton()
                setEditById(null)

                resetForm();
                setUploadedFile(null)

            }, 1500);
        }
        else {
            setLoading(false)

            toast.error(`Jury member/ expert lecture/ mentor requirement is not ${editById ? "updated" : "created"}`)

        }
        console.log(responseData, "responseDataresponseData");


    };


    return (
        <Box>
            <Box>
                {loading && <FullPageLoader />}

                <ProfileContainer p={{ xs: 0 }} mb={2} >
                    <Container maxWidth="lg" >
                        <ResponsiveBox mt={2}>
                            <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
                                <Typography variant="h6" gutterBottom>Jury member/ expert lecture/ mentor requirement</Typography>
                                <Divider />
                                <Box>
                                    <Formik
                                        innerRef={formikRef}

                                        initialValues={{
                                            RequirementCampus: "",
                                            mentor: "",
                                            Expertise: "",
                                            TotalVacancies: "",
                                            fromDate: "",
                                            toDate: "",
                                            details: ""
                                        }}
                                        validationSchema={validationSchema}
                                        onSubmit={(values, resetForm) => {
                                            handleSubmit(values, resetForm)
                                        }}
                                    >
                                        {({ isSubmitting, values, resetForm, setFieldValue, errors, touched, handleChange, handleBlur }) => (
                                            <Form>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 2,
                                                        mt: 2
                                                    }}
                                                >


                                                    <Grid container spacing={2}>
                                                        <Grid item size={{ md: 4, xs: 12, sm: 6 }} >


                                                            <CustomInputLogin
                                                                label="Requirement for the Campus"
                                                                name="RequirementCampus"
                                                                custPlaceholder="Enter Campus Name"
                                                                inputType="input"
                                                            // image={email_input_icon}
                                                            />

                                                        </Grid>
                                                        <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                            <CustomDropdownMui
                                                                label="Jury member/ expert lecture/ mentor"
                                                                name="mentor"
                                                                options={mentorList}
                                                                custPlaceholder="Select Jury member/ expert lecture/ mentor"
                                                            // image={country_icon}
                                                            // important={true}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                            <CustomDropdownMui
                                                                label="Expertise"
                                                                name="Expertise"
                                                                options={categoryList}
                                                                custPlaceholder="Select Expertise"
                                                            // image={country_icon}
                                                            // important={true}
                                                            />
                                                        </Grid>
                                                        {/* <Grid size={{md:4}}> */}
                                                        <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                            <CustomInputLogin
                                                                label="Total number of Vacancies"
                                                                name="TotalVacancies"
                                                                custPlaceholder="Enter Total number of Vacancies"
                                                                inputType="input"
                                                            // image={email_input_icon}
                                                            />
                                                        </Grid>
                                                        <CustomFromAndToDate label1="From Date" label2="To Date" />
                                                        {/* </Grid> */}



                                                        <Grid size={{ md: 12, xs: 12, sm: 12 }}>
                                                            <CustomInputLogin
                                                                label="Details of Requirements"
                                                                name="details"
                                                                custPlaceholder="details"
                                                                inputType="textarea"
                                                            />
                                                        </Grid>

                                                        {/* <Grid size={{ md: 4, xs: 12, sm: 0 }}></Grid>
                                                        <Grid size={{ md: 4, xs: 12, sm: 6 }}></Grid> */}

                                                        <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "end" }}>
                                                            <Button
                                                                onClick={() => {
                                                                    handleAddFormGoBackButton()
                                                                    resetForm()
                                                                    setEditById(null)
                                                                }}
                                                                variant="contained"
                                                                sx={{
                                                                    textTransform: "none",
                                                                    color: "black",
                                                                    fontSize: "16px",
                                                                    padding: { xs: "0px 20px", md: "0px 50px" },
                                                                    marginRight: "5px",
                                                                    boxShadow: 1,
                                                                    border: "1px solid #ced4da",
                                                                    minHeight: "40px",
                                                                    // borderRadius: "23px",
                                                                    background: "white 0% 0% no-repeat padding-box",
                                                                    "&:hover": {
                                                                        backgroundColor: "white",
                                                                    },
                                                                }}
                                                            >
                                                                Go back
                                                            </Button>
                                                            <Button
                                                                type="submit"
                                                                variant="contained"
                                                                sx={{
                                                                    textTransform: "none",
                                                                    color: "white",
                                                                    fontSize: "16px",
                                                                    padding: { xs: "0px 20px", md: "0px 50px" },

                                                                    boxShadow: "none",
                                                                    minHeight: "40px",
                                                                    // borderRadius: "23px",
                                                                    background: "var(--main-color) 0% 0% no-repeat padding-box",
                                                                    "&:hover": {
                                                                        backgroundColor: "var(--main-color)",
                                                                    },
                                                                }}
                                                            >
                                                                {editById ? "Update" : "Submit"}
                                                            </Button>
                                                        </Grid>

                                                    </Grid>




                                                </Box>
                                            </Form>
                                        )}
                                    </Formik>
                                </Box>
                            </Paper>
                        </ResponsiveBox>
                    </Container>
                </ProfileContainer>
            </Box>
            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </Box>
    )
}

export default MentorRequirement